import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "floating-unpaid-container"
}
const _hoisted_2 = { class: "badge-icon-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "badge-count"
}
const _hoisted_4 = { class: "badge-amount" }
const _hoisted_5 = { class: "panel-header" }
const _hoisted_6 = { class: "panel-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_UnPaidEntrants = _resolveComponent("UnPaidEntrants")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.shouldShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_Transition, { name: "badge-pop" }, {
            default: _withCtx(() => [
              (!_ctx.isExpanded)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "floating-badge",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expandPanel && _ctx.expandPanel(...args))),
                    onKeydown: [
                      _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.expandPanel && _ctx.expandPanel(...args)), ["enter"])),
                      _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.expandPanel && _ctx.expandPanel(...args)), ["prevent"]), ["space"]))
                    ],
                    tabindex: "0",
                    role: "button",
                    "aria-label": "View unpaid items"
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_v_icon, {
                        color: "white",
                        size: "28"
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-cart-outline")
                        ])),
                        _: 1
                      }),
                      (_ctx.unpaidItemCount > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.unpaidItemCount), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.userDataStore.getFormattedBalanceDue), 1)
                  ], 32))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (_ctx.isExpanded)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "floating-panel",
                    role: "dialog",
                    "aria-labelledby": "unpaid-panel-title",
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.collapsePanel && _ctx.collapsePanel(...args)), ["esc"]))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex flex-column" }, [
                        _createElementVNode("h3", {
                          id: "unpaid-panel-title",
                          class: "panel-title"
                        }, "Unpaid Items"),
                        _createElementVNode("p", { class: "not-secured-text mb-4 pca-red" }, "Registration is not secured until checkout/payment has been successfully processed.")
                      ], -1)),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-close",
                        size: "small",
                        variant: "text",
                        color: "pca-dark-grey",
                        onClick: _ctx.collapsePanel,
                        "aria-label": "Close unpaid items panel"
                      }, null, 8, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_UnPaidEntrants, {
                        showPayBalanceBtn: true,
                        isFloating: true
                      })
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_ctx.isExpanded)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "floating-backdrop",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.collapsePanel && _ctx.collapsePanel(...args))),
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}